const forgotPasswordPath = '/auth/current-user';
export default forgotPasswordPath;
